/* eslint-disable jsx-a11y/anchor-is-valid */
import "bootstrap/dist/css/bootstrap.min.css";
import GridBoard from "./GridBoard";
import Header from "./Header";
// import "./App.css";
import extensionsApi from './../apis/extensionsApi';
import { useEffect, useState } from 'react';
import { Button, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

function MainPage(props) {
    const [listGroups, setListGroups] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [listGroupCheckedOld, setListGroupCheckedOld] = useState([]);
    const [listGroupChecked, setListGroupChecked] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [isCheckAll, setIsCheckAll] = useState(true);

    useEffect(() => {

        const retrieveAllGroupName = (lsExtensions) => {
            let groups = [];

            for (let ii = 0; ii < lsExtensions.length; ii++) {
                for (let jj = 0; jj < lsExtensions[ii].groupName.length; jj++) {
                    if (!groups.includes(lsExtensions[ii].groupName[jj])) {
                        groups.push(lsExtensions[ii].groupName[jj]);
                    }
                }
            }

            // console.log("Groups are: ", groups);

            setListGroups(groups);
            setListGroupChecked(groups);

            return groups;
        }

        const fetchExtensions = async () => {
            try {
                const response = await extensionsApi.getAll();

                // console.log("Fetch extensions successfully: ", response);

                // setListExtensions(response);

                retrieveAllGroupName(response);

                setLoaded(true);
            } catch (error) {
                // console.log("Failed to fetch extensions: ", error);
                props.onHandleChange(false);
            }
        }


        fetchExtensions();

        // const interval = setInterval(() => {
        //     fetchExtensions();
        // }, 2000);

        // return () => clearInterval(interval);
    }, []);

    const genCheckBox = () => {
        const items = [];
        for (let i = 0; i < listGroups.length; i++) {
            items.push(
                <FormGroup
                    key={i}
                    check
                // inline
                >
                    <Input
                        type="checkbox"
                        value={listGroups[i]}
                        defaultChecked={listGroupChecked.includes(listGroups[i])}
                        checked={listGroupChecked.includes(listGroups[i])}
                        // checked={isCheckAll & listGroupChecked.includes(listGroups[i])}
                        // defaultChecked={true}
                        onChange={(e) => {
                            // alert(e.target.checked);

                            // if(listGroupCheckedTmp.length === 0) {
                            //   setListGroupCheckedTmp(listGroupChecked);
                            // }
                            const vv = [...listGroupChecked];

                            if (e.target.checked) {
                                if (!vv.includes(e.target.value)) {
                                    vv.push(e.target.value)
                                    setListGroupChecked(vv);
                                    setIsCheckAll(true);
                                }
                            } else {
                                if (vv.includes(e.target.value)) {
                                    setListGroupChecked(vv.filter(ez => ez !== e.target.value));
                                }
                            }

                            // console.log("VXV: ", listGroupChecked);
                        }}
                    />
                    <Label check>
                        {listGroups[i]}
                    </Label>
                </FormGroup>
            )
        }

        return items;
    }

    return (
        <div className="App">
            <Header />

            <div className='d-flex justify-content-end'>
                <Button className='justify-content-end'
                    color='primary'
                    outline
                    onClick={() => {
                        setListGroupCheckedOld(listGroupChecked);
                        setModalIsOpen(!modalIsOpen);
                    }}
                >
                    Choose Group
                </Button>
                <Button
                    style={{marginLeft: "1rem"}}
                    onClick={() => {
                        localStorage.removeItem("token");
                        props.onHandleChange(false);
                    }}
                >
                    Log out
                </Button>
            </div>
            <Modal
                isOpen={modalIsOpen}
            >
                <ModalHeader>
                    Chọn Groups
                </ModalHeader>
                <ModalBody>
                    <Form>
                        {/* <FormGroup
                            check
                            // inline
                        >
                            <Input type="checkbox" />
                            <Label check>
                                Some input
                            </Label>
                        </FormGroup>
                        <FormGroup
                            check
                            // inline
                        >
                            <Input type="checkbox" 
                                onChange={(e) => {
                                    alert(e.target.checked)
                                }}
                            />
                            <Label check>
                                Some other input
                            </Label>
                        </FormGroup> */}
                        <FormGroup
                            style={{padding: 0}}
                            check
                            // inline
                        >
                            {/* <Input
                                type="checkbox"
                                defaultChecked={isCheckAll}
                                check={isCheckAll}
                                // value={isCheckAll}
                                onChange={(e) => {
                                    if(e.target.checked) {
                                        setListGroupChecked(listGroups);
                                        setIsCheckAll(true);
                                    } else {
                                        setListGroupChecked([]);
                                        setIsCheckAll(false);
                                    }
                                }}
                            />
                            <Label check>
                                {listGroupChecked.length === listGroups.length ? 'Uncheck all' : 'Check all'}
                            </Label>
                            <hr/> */}
                            <Label>
                                {listGroupChecked.length === listGroups.length ? <FontAwesomeIcon color="blue" icon={faCheckCircle} /> : ""}
                            </Label>
                            <a
                                // eslint-disable-next-line no-script-url
                                href="javascript:void(0)"
                                style={{textDecoration: 'none'}}
                                onClick={() => {
                                    if(listGroupChecked.length === listGroups.length) {
                                        setListGroupChecked([]);
                                        setIsCheckAll(false);
                                    } else {
                                        setListGroupChecked(listGroups);
                                        setIsCheckAll(true);
                                    }
                                }}
                            >
                                {listGroupChecked.length === listGroups.length ? ' Uncheck all' : 'Check all'}
                            </a>
                        </FormGroup>
                        <hr/>

                        {loaded ? genCheckBox() : ''}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color='primary'
                        onClick={() => {
                            setModalIsOpen(!modalIsOpen);
                            // alert(listGroupChecked);

                            // setListGroupChecked(listGroupCheckedTmp);
                            // setListGroupCheckedTmp([]);
                            // setCurrDataMatchGroupsSelected(listExtensions);
                            // console.log("HHH: ", listGroupChecked);
                        }}
                    >
                        OK
                    </Button>
                    <Button
                        onClick={() => {
                            setModalIsOpen(!modalIsOpen);
                            // console.log("HHH2: ", listGroupChecked);
                            // setListGroupCheckedTmp([]);
                            setListGroupChecked(listGroupCheckedOld);
                            // console.log("HHH2: ", listGroupChecked);
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <hr />

            {loaded ? <GridBoard lsGrSelected={listGroupChecked} onHandleChange={props.onHandleChange}/> : ''}
        </div>
    );
}

export default MainPage;